// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__wptzf","col":"styles_col__jPs2c","fulfillmentStatus":"styles_fulfillmentStatus__2QObz","emailCol":"styles_emailCol__MEFOj"};